import { Component, Vue } from 'vue-property-decorator' ;
import { namespace } from 'vuex-class';
import { DOCUMENT_MODULE_NAMESPACE, DOCUMENT_LOADERS, DOCUMENT_SET_DOCUMENT_PARAMETER } from '../../../store/document';
import { IDocumentParamter } from '../../../models/documents';

const DocumentStore= namespace(DOCUMENT_MODULE_NAMESPACE)

@Component({
  components:{
    'document-attachments': async () => import('../components/document-attachments/DocumentsAttachments.vue')
  }
})
class DocumentAttachmentList extends Vue {

    @DocumentStore.Getter documentParameter: IDocumentParamter;
    @DocumentStore.Getter documentTypes: any[]
    @DocumentStore.Getter loaders: Map<string,boolean>

    @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENT_PARAMETER)
    storeSetDocumentParameter: (payload: IDocumentParamter) => void

    get documentType(){
        var { fk_attachment_type } = this.documentParameter
        return this.documentTypes.find(documentType => documentType.fk_attachment_type === fk_attachment_type[0] )
    }

    get coCategoriesLoader(){
      return this.loaders.get(DOCUMENT_LOADERS.CATEGORIES_LOADER)
    }

    created() {
        const {params} = this.$route
        this.storeSetDocumentParameter({fk_attachment_type: [parseInt(params.id)], block: [] })
    }
}

export default DocumentAttachmentList



// WEBPACK FOOTER //
// ./src/containers/documents/document-attachment-list/index.ts